import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/Home";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Terms";
import DeleteAccount from "../pages/DeleteAccount";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            {/* Canonical policy URL — this is what the mobile app and Play Console link to */}
            <Route path="/privacy-policy" element={<Privacy />} />
            {/* Alias kept so older app builds linking /policies/privacy keep working */}
            <Route path="/policies/privacy" element={<Privacy />} />
            <Route path="/terms-of-service" element={<Terms />} />
            {/* Google Play account-deletion requirement: web path to request deletion */}
            <Route path="/delete-account" element={<DeleteAccount />} />
            {/* Add other routes as needed */}
        </Routes>
    );
};

export default AppRoutes;
